import React from "react";
import { useIntl } from "umi";

import { Checkbox, Dropdown, Icon, List} from "tea-component";
import {useLocalOptions, useSortValue} from "@/pages/dashboard/utils/customHook";

import SvgIcon from '@/pages/home/components/SvgIcon';

export const defaultOptionValues = ["sum", "avg_no_null", "avg_no_null_zero", "max", "min", "count"]
export const defaultValue = ["sum", "avg_no_null"]

export default function ShowMoreStatistics (props) {

  const {
    value = defaultValue,
    onChange,
    options,
    onOpen,
    onClose
  } = props
  const allOpt = options ? options : useLocalOptions(defaultOptionValues)
  const sortValue = useSortValue(allOpt);
  const titleText = useIntl().formatMessage({id: "show_more_statistics_title"})
  const tips = useIntl().formatMessage({id: "show_more_statistics_tips"})
  return (<>
    <Dropdown
      boxClassName="table-line-select-box"
      clickClose={false}
      placement={"bottom-end"}
      appearance="pure"
      button={<span><SvgIcon className='overall-conext-icon' type='set-up' /></span>}
      onOpen={onOpen}
      onClose={onClose}
      footer={(<p style={{fontSize: 12, color: "#bbb", fontWeight: 400}}>{tips}</p>)}
    >
      {
        close => (
          <>
            <p className="table-line-select-box-title">{titleText}</p>
            <Checkbox.Group
              value={value}
              onChange={(value) => {
                if (onChange) {
                  onChange(sortValue(value));
                }
              }}
              layout="column"
            >
              <List type="option">
                {
                  allOpt?.map?.(opt => (<List.Item key={opt.value}>
                    <Checkbox name={opt.value}>{opt.text}</Checkbox>
                  </List.Item>))
                }
              </List>
            </Checkbox.Group>
          </>
        )
      }
    </Dropdown>
  </>)
}
